import CommercialIcon from "Assets/Img/CommercialIcon";
import ResidentialIcon from "Assets/Img/ResidentialIcon";
import React from "react";
import { formatDate } from "utils/Common/Date";

const ProjectHeader = ({ projectData }: { projectData?: any }) => {
  const adminName =
    `${projectData?.admin?.firstName ?? ""} ${projectData?.admin?.lastName ?? ""}`.trim();
  return (
    <div className="proj-header">
      <div className="ph-thumb">
        {projectData?.projectType === "commercial" ? (
          <CommercialIcon />
        ) : (
          <ResidentialIcon />
        )}
      </div>
      <div className="ph-info">
        <div className="ph-name">
          {projectData?.projectName ?? "-"}
          <span className="precon-subtitle">
            {projectData?.status === "pre_construction"
              ? "Pre-con pending"
              : "-"}
          </span>{" "}
          <span className="type-tag">{projectData?.projectType ?? "-"}</span>
        </div>
        <div className="ph-meta">
          <div className="ph-meta-item">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <rect
                x="1"
                y="2"
                width="10"
                height="9"
                rx="1"
                stroke="var(--tx2)"
                strokeWidth="1"
              />
              <line
                x1="1"
                y1="5"
                x2="11"
                y2="5"
                stroke="var(--tx2)"
                strokeWidth="1"
              />
            </svg>
            Report due:{" "}
            <strong>
              {formatDate(projectData?.preConstructionReportDueDate, false) ||
                "-"}
            </strong>
          </div>
          <div className="ph-meta-item">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <rect
                x="1"
                y="1"
                width="10"
                height="10"
                rx="1.5"
                stroke="var(--tx2)"
                strokeWidth="1"
              />
              <line
                x1="3"
                y1="4"
                x2="9"
                y2="4"
                stroke="var(--tx2)"
                strokeWidth="1"
              />
              <line
                x1="3"
                y1="6.5"
                x2="9"
                y2="6.5"
                stroke="var(--tx2)"
                strokeWidth="1"
              />
            </svg>
            {projectData?.lender?.companyName ?? "-"}
          </div>
          <div className="ph-meta-item">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <circle cx="6" cy="5" r="3" stroke="var(--tx2)" strokeWidth="1" />
              <path
                d="M1 11c0-2.2 2.2-4 5-4s5 1.8 5 4"
                stroke="var(--tx2)"
                strokeWidth="1"
                fill="none"
              />
            </svg>
            {adminName || "-"}
          </div>
        </div>
      </div>
      <div className="ph-deadline">
        Due{" "}
        <span>
          {formatDate(projectData?.preConstructionReportDueDate, false) || "NA"}
        </span>
      </div>
    </div>
  );
};

export default ProjectHeader;
